const LOAD_DATA_JOB_OVERVIEW           = 'LOAD_DATA_JOB_OVERVIEW'
const LOAD_DATA_JOB_OVERVIEW_SUCCESS   = 'LOAD_DATA_JOB_OVERVIEW_SUCCESS'
const LOAD_DATA_JOB_OVERVIEW_FAILED    = 'LOAD_DATA_JOB_OVERVIEW_FAILED'
const UNMOUNT_DATA_JOB_OVERVIEW        = 'UNMOUNT_DATA_JOB_OVERVIEW'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const jobOverviewReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_JOB_OVERVIEW:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_JOB_OVERVIEW_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_JOB_OVERVIEW_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_JOB_OVERVIEW:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default jobOverviewReducer;